import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/landing';
function Stars({
  size = 'h-4 w-4'
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-232" data-mp="3mgiqi6u3idye">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-ember-500 text-ember-500`} data-id="element-233" data-mp="3r8kc4jd5lh13" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-234" data-mp="3k8m5azwrsf">
      <div className="mx-auto max-w-6xl px-4 sm:px-5" data-id="element-235" data-mp="44w24lwzpx5w">
        <div className="text-center" data-id="element-236" data-mp="91meay5oc8m1">
          <h2 id="testimonials-title" className="mx-auto max-w-3xl text-balance font-display text-[2rem] font-black leading-tight text-navy-900 sm:text-5xl" data-id="element-237" data-mp="92pa9khut18t">
            What Other Physical Therapists Are Saying
          </h2>
          <div className="mt-5 inline-flex items-center gap-3 rounded-full bg-white px-5 py-2.5 ring-1 ring-navy-900/10" data-id="element-238" data-mp="2ftevsck3njz0">
            <Stars size="h-5 w-5" data-id="element-239" data-mp="1sm3vxu0ni4f4" />
            <span className="text-lg font-black text-navy-900" data-id="element-240" data-mp="1ntsxkvlk6qoo">4.9/5</span>
          </div>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-241" data-mp="1iuptpehbeqia">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-navy-900/10" data-id="element-242" data-mp="1eto31m1grmrx">
              <Stars data-id="element-243" data-mp="2bjn999u5697c" />
              <blockquote className="mt-4 text-base leading-relaxed text-navy-900/85" data-id="element-244" data-mp="2bi3vbpvyka8q">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-245" data-mp="26ktule34cc5l">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand-100" loading="lazy" data-id="element-246" data-mp="22hnt0jqyb95g" />
                <div data-id="element-247" data-mp="r4uzp4iiicna">
                  <p className="font-extrabold text-navy-900" data-id="element-248" data-mp="m4gs1nktp4ps">{t.name}</p>
                  <p className="text-sm text-navy-900/65" data-id="element-249" data-mp="m35pts71050s">
                    {t.role} — {t.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CtaButton className="mt-12" label="I want to feel more prepared for my cases" data-id="element-250" data-mp="sicwigi9v96j" />
      </div>
    </section>;
}